import * as React from "react";
const SvgAvatar = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 96 96", ...props }, /* @__PURE__ */ React.createElement("title", null, "Artboard 1 copy 6"), /* @__PURE__ */ React.createElement("circle", { cx: 48, cy: 48, r: 48, style: {
  fill: "#5b5753"
} }), /* @__PURE__ */ React.createElement("circle", { cx: 48, cy: 28.98, r: 16.5, style: {
  fill: "none",
  stroke: "#009fdf",
  strokeMiterlimit: 10,
  strokeWidth: 6
} }), /* @__PURE__ */ React.createElement("path", { d: "M86.83 76.21A39.13 39.13 0 0 0 70.74 48l-2-1.47-1.8 1.77a27 27 0 0 1-37.78 0l-1.8-1.77-2 1.47A39.13 39.13 0 0 0 9.17 76.21a48.3 48.3 0 0 0 6 6.79 33 33 0 0 1 11.69-28.69 33 33 0 0 0 42.27 0A33 33 0 0 1 80.83 83a48.3 48.3 0 0 0 6-6.79", style: {
  fill: "#009fdf"
} }));
export default SvgAvatar;
